import script from "./MsgContComp.vue?vue&type=script&setup=true&lang=js"
export * from "./MsgContComp.vue?vue&type=script&setup=true&lang=js"

import "./MsgContComp.vue?vue&type=style&index=0&id=5bdf272a&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bdf272a"]])

export default __exports__